module.exports = __webpack_public_path__ + "img/quiz-fail.b3f9cede.png";